/*global jQuery:false */
jQuery(document).ready(function () {
    'use strict';
    var openAislesBtn = $('.openAisle');
    var openShopBasketBtn = $('.openShopBaskets');
    var subCatShopBasket = document.getElementsByClassName('lm--aisles-container shop-basket');
	var subCatAisles = document.getElementsByClassName('lm--aisles-container aisles');
	
	

    // On click, Open Aisles
    openAislesBtn.bind('click', function (e) {
        handleSelectCategoryClick(this);

        closeActiveSubCategory(openShopBasketBtn, subCatShopBasket);

        $(subCatAisles).slideToggle('fast');

        e.preventDefault();
    });

    // On click, Open ShopBaskets
    openShopBasketBtn.bind('click', function (e) {
        handleSelectCategoryClick(this);

        closeActiveSubCategory(openAislesBtn, subCatAisles);

        $(subCatShopBasket).slideToggle('fast');

        e.preventDefault();
    });

    // On click, Open subCart
    jQuery('.openSubCat').bind('click', function (e) {
        // init //
        $('.lm--btn-aisles').removeClass('active');
        $('.lm--btn-aisles').attr('aria-expanded', 'false');
        $('.lm--aisles-container').hide();
        //

        var subCat = document.getElementsByClassName('lm--sub-cat-container');
        $(this).toggleClass('active');

        if ($(this).attr('aria-expanded') == 'false') {
            $(this).attr('aria-expanded', 'true');
        } else {
            $(this).attr('aria-expanded', 'false');
        }

        jQuery(subCat).slideToggle('fast');

        e.preventDefault();
    });
});

var handleSelectCategoryClick = function(elem) {
    // init //
    $('.lm--btn-sub-cat').removeClass('active');
    $('.lm--btn-sub-cat').attr('aria-expanded', 'false');
    $('.lm--sub-cat-container').hide();
    //

    $(elem).toggleClass('active');

    if ($(elem).attr('aria-expanded') == 'false') {
        $(elem).attr('aria-expanded', 'true');
    } else {
        $(elem).attr('aria-expanded', 'false');
    }
}

var closeActiveSubCategory = function(subCatBtn, subCat) {
    if ($(subCatBtn).hasClass('active')) {
        $(subCatBtn).removeClass('active');
        $(subCat).slideToggle('fast');
    }
}
